module.exports = __webpack_public_path__ + "img/cloud4.c58094b5.png";